function getStepperState(state) {
  return {
    lastStep: state.stepperProf.lastStep,
    getLastStepError: state.stepperProf.getLastStepError,
    currentStep: state.stepperProf.currentStep,
    preventTransition: state.stepperProf.preventTransition,
    nextStepperRoute: state.stepperProf.nextStepperRoute,
    stepperFormRef: state.stepperProf.stepperFormRef,
    loadingStepperState: state.stepperProf.loadingStepperState,
    snackAction: state.stepperProf.snackAction
  };
}

export { getStepperState };
